module.exports = __webpack_public_path__ + "img/resource-tech-image-67.e288868a.jpg";